import { createSelector } from 'reselect';

export const getComponentState = state => state.promotionalEditor;

export const getTemplateCode = createSelector(
    getComponentState,
    (state) => state.templateCode
);
export const getQuantity = createSelector(
    getComponentState,
    (state) => state.variables.quantity
);
export const getLogo = createSelector(
    getComponentState,
    (state) => state.variables.logo
);
export const getPromotionalItem = createSelector(
    getComponentState,
    (state) => state.promotionalItem
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getAddingToCart = createSelector(
    getComponentState,
    (state) => state.addingToCart
);
export const getDepartment = createSelector(
    getComponentState,
    (state) => state.department
);
export const getFetchingDepartment = createSelector(
    getComponentState,
    (state) => state.fetchingDepartment
);
export const getClinicName = createSelector(
    getComponentState,
    (state) => state.variables.clinic_name
);
export const getPhone = createSelector(
    getComponentState,
    (state) => state.variables.phone
);
export const getInk = createSelector(
    getComponentState,
    (state) => state.variables.ink
);
export const getNotes = createSelector(
    getComponentState,
    (state) => state.variables.notes
);
export const getIsFavorite = createSelector(
    getComponentState,
    (state) => state.isFavorite
);
export const getAddingFavorite = createSelector(
    getComponentState,
    (state) => state.addingFavorite
);
export const getCheckingFavorite = createSelector(
    getComponentState,
    (state) => state.checkingFavorite
);
export const getSavingWork = createSelector(
    getComponentState,
    (state) => state.savingWork
);
export const getAction = createSelector(
    getComponentState,
    (state) => state.action
);